/* Perf Phase 4: carga diferida de la imagen "hover" (secundaria) de las tarjetas de producto.
   La imagen se entrega en data-hover-src / data-hover-srcset y se carga en el primer
   hover / focus / tap sobre la tarjeta. En móvil (sin hover) no se descarga nunca.
   Usa delegación de eventos para cubrir tarjetas añadidas por AJAX (filtros/paginación).
   Un <noscript> en la plantilla garantiza que sin JS la imagen se vea igual.
   No cambia lo que se renderiza; solo cuándo se descargan los bytes. */
(function () {
  function swap(card) {
    var imgs = card.querySelectorAll('img[data-hover-src]');
    for (var i = 0; i < imgs.length; i++) {
      var img = imgs[i];
      if (img.dataset.hoverSrcset) { img.srcset = img.dataset.hoverSrcset; img.removeAttribute('data-hover-srcset'); }
      img.src = img.dataset.hoverSrc;
      img.removeAttribute('data-hover-src');
    }
  }
  function onInteract(e) {
    var t = e.target;
    if (!t || !t.closest) return;
    var card = t.closest('.hdt-card-product');
    if (card) swap(card);
  }
  ['mouseover', 'focusin', 'touchstart'].forEach(function (ev) {
    document.addEventListener(ev, onInteract, { capture: true, passive: true });
  });
})();
